// src/services/nePasContacter.js — POSER ET LEVER « ne pas contacter », depuis
// n'importe quel écran qui affiche la marque.
//
// La marque vit sur la FICHE, et la barrière est serveur : c'est lui qui refuse
// ensuite l'InMail, l'appel de l'agent, l'invitation d'entretien et la
// convocation. Le front ne fait que la poser, la lever, et la MONTRER.
//
// Vécu 09.09 : « quand un candidat est en ne pas contacter je peux plus
// l'enlever de cette liste ». La marque s'AFFICHE sur cinq écrans (carte du
// besoin, vivier, listes de sourcing, suivi sourceur, fiche candidat) et ne se
// LEVAIT que sur un seul — la fiche dépliée de la liste Candidats, le seul
// endroit à porter l'appel. Partout ailleurs on lisait « ne pas contacter »
// sans aucun moyen d'agir : une impasse, et rien à l'écran ne disait où aller.
//
// L'appel vit donc ICI, une fois, pour que brancher un écran de plus soit une
// ligne — et pour qu'il n'y ait qu'un endroit où corriger la façon dont on
// parle au serveur.
import APIService from './api';

const BASE = 'https://besoins-tat-production.up.railway.app';

/**
 * Pose ou lève la marque. `candidatId` est l'id de FICHE (canonical_candidate_id
 * sur les écrans qui l'exposent) ; le serveur sait aussi résoudre un id legacy.
 *
 * Rend { ok, message } ou { ok:false, error } — jamais une exception : chaque
 * appelant affiche le message tel quel, personne n'invente le sien.
 */
export async function definirNePasContacter(candidatId, actif, motif = null) {
  if (candidatId == null || candidatId === '') {
    return { ok: false, error: "Cette ligne n'est rattachée à aucune fiche candidat — ouvrez la fiche pour lever la marque." };
  }
  try {
    const r = await fetch(`${BASE}/candidats/${candidatId}/ne-pas-contacter`, {
      method: 'PUT',
      headers: { Authorization: `Bearer ${APIService.getToken()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ actif, motif: motif || null }),
    });
    const j = await r.json().catch(() => ({}));
    // « Pas encore côté serveur » = la ROUTE manque (404 sans notre JSON, ou
    // 501). Un 404 qui porte notre { success:false, error } est une vraie
    // réponse (« Candidat introuvable ») : on l'affiche telle quelle.
    if (r.status === 501 || (r.status === 404 && j.success !== false)) {
      return { ok: false, absente: true, error: 'La marque « ne pas contacter » arrive côté serveur.' };
    }
    if (!r.ok || j.success === false) return { ok: false, error: j.error || `Impossible (${r.status})` };
    return { ok: true, message: j.message || (actif ? 'Marqué « ne pas contacter ».' : 'Contact de nouveau autorisé.'), data: j.data };
  } catch (e) {
    return { ok: false, error: e.message };
  }
}

/** Le texte de la confirmation avant de LEVER — le motif y figure : c'est ce
 *  que le collègue qui a posé la marque voulait qu'on lise avant de l'enlever. */
export function confirmationLever(nom, motif) {
  return {
    title: 'Autoriser de nouveau le contact ?',
    message: `${(nom || 'Ce candidat').trim()} est marqué « ne pas contacter »${motif ? ` (${motif})` : ''}. `
      + 'Lever la marque rouvre les InMails, appels et invitations.',
    confirmLabel: 'Autoriser le contact',
  };
}
